<template>
  <div class="mb-4">
    <pageTitle
      :title="title"
      :arrow-back="false"
      link="Exportar a excel"
      class="mb-2"
    />

    <DataTableNaf :fields="columns" :items="items" :per-page="5">
      <template #cell(prov)="{ item }">
        <span>{{ item.articulo }}</span>
      </template>

      <template #cell(total)="{ item }">
        <span>{{ item.total }}</span>
      </template>

      <template #cell(uds)="{ item }">
        <span>{{ item.uds }}</span>
      </template>

      <template #cell(desc)="{ item }">
        <span>{{ item.desc }}</span>
      </template>

      <template #cell(comp)="{ item }">
        <span
          :style="{
            color:
              item.comp >= 100
                ? 'var(--fc-brand-02)'
                : item.comp < 100
                  ? 'var(--fc-danger)'
                  : '',
          }"
        >
          {{ item.comp }}%</span
        >
      </template>
    </DataTableNaf>
  </div>
</template>

<script>
export default {
  name: 'TablaDtoArticulo',
  data() {
    return {
      title: 'Comparación descuentos por artículo',
      columns: [
        {
          key: 'articulo',
          sortable: true,
          label: 'Artículo',
        },
        {
          key: 'total',
          sortable: true,
          label: 'Total compras',
          class: 'justify-content-center',
        },
        {
          key: 'uds',
          sortable: true,
          label: 'Unidades',
          class: 'justify-content-center',
        },
        {
          key: 'desc',
          sortable: true,
          label: 'Descuento acumulado',
          class: 'justify-content-center',
        },
        {
          key: 'comp',
          sortable: true,
          label: 'Comparación',
          class: 'justify-content-center',
        },
      ],
      items: [
        {
          articulo: 'Artículo 1',
          total: '10.000€',
          uds: 10.0,
          desc: '1.000€ (10%)',
          comp: 97.78,
        },
        {
          articulo: 'Artículo 2',
          total: '10.000€',
          uds: 10.0,
          desc: '1.000€ (10%)',
          comp: 57.98,
        },
        {
          articulo: 'Artículo 3',
          total: '10.000€',
          uds: 10.0,
          desc: '1.000€ (10%)',
          comp: 105.31,
        },
        {
          articulo: 'Artículo 4',
          total: '10.000€',
          uds: 10.0,
          desc: '1.000€ (10%)',
          comp: 150.5,
        },
        {
          articulo: 'Artículo 5',
          total: '10.000€',
          uds: 10.0,
          desc: '1.000€ (10%)',
          comp: 39.04,
        },
        {
          articulo: 'Artículo 6',
          total: '10.000€',
          uds: 10.0,
          desc: '1.000€ (10%)',
          comp: 97.78,
        },
        {
          articulo: 'Artículo 7',
          total: '10.000€',
          uds: 10.0,
          desc: '1.000€ (10%)',
          comp: 57.98,
        },
        {
          articulo: 'Artículo 8',
          total: '10.000€',
          uds: 10.0,
          desc: '1.000€ (10%)',
          comp: 105.31,
        },
        {
          articulo: 'Artículo 9',
          total: '10.000€',
          uds: 10.0,
          desc: '1.000€ (10%)',
          comp: 150.5,
        },
        {
          articulo: 'Artículo 10',
          total: '10.000€',
          uds: 10.0,
          desc: '1.000€ (10%)',
          comp: 39.04,
        },
      ],
    };
  },
};
</script>
